module.exports = __webpack_public_path__ + "static/media/c1.54ea4a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/thumbnails/c1.png
// module id = 331
// module chunks = 0